import { z } from 'zod'
import { intString, optionalText, regexField, requiredId, requiredText } from '../../lib/forms/rules'
import { COLUMN_BYTES } from '../../lib/columnBytes'

/** "Diğer" talep türü id'si; seçilince ayrı zorunlu açıklama alanı görünür (008). */
export const OTHER_TYPE_ID = -1
const PNR_RE = /^[A-Za-z0-9]{6}$/

/**
 * Yeni bilet talebi form şeması (020). Mevcut kurallar birebir: PNR 6 alfanumerik, ad zorunlu,
 * tür/makam/durum zorunlu seçim, ücret opsiyonel tam sayı, gerekçe zorunlu; "Diğer" türde
 * `otherRequestNote` koşullu zorunlu (FR-008). `z.infer` form değer tipini verir.
 */
export const ticketRequestSchema = z
  .object({
    pnr: regexField(PNR_RE, 'validation.pnr'),
    nameSurname: requiredText(255, COLUMN_BYTES.ticketNameSurname),
    typeId: requiredId(),
    officeId: requiredId(),
    statusId: requiredId(),
    ticketPrice: intString(),
    requestNote: requiredText(4000, COLUMN_BYTES.ticketNote),
    otherRequestNote: optionalText(4000, COLUMN_BYTES.ticketNote),
  })
  .superRefine((val, ctx) => {
    if (val.typeId === OTHER_TYPE_ID && !val.otherRequestNote.trim()) {
      ctx.addIssue({ code: 'custom', path: ['otherRequestNote'], message: 'validation.required' })
    }
  })

export type TicketRequestForm = z.infer<typeof ticketRequestSchema>

/** Form varsayılanları (boş). */
export const ticketRequestDefaults: TicketRequestForm = {
  pnr: '',
  nameSurname: '',
  typeId: null,
  officeId: null,
  statusId: null,
  ticketPrice: '',
  requestNote: '',
  otherRequestNote: '',
}
